import { breakdanceStoreActions } from "@/store/actions/store-actions";
import { uiStore, documentStore } from "@/store/store";
import { findNode, findNodeParent } from "@/lib/tree/tree";
import { stopInlineEditing } from "./inline-editor";

export function registerInlineEditorActions() {
    
  // stop inline editing if the user activates an element outside the inlineEditingContext.elementId
  breakdanceStoreActions.register.onActivatedElement(async ({ elementId }) => {

    if (!uiStore.inlineEditingContext?.elementId) {
      return;
    }

    const inlineEditingElementId = uiStore.inlineEditingContext.elementId;
    
    if (elementId === inlineEditingElementId) {
      return;
    }

    const activatedElement = findNode(documentStore.document.tree, elementId);
    const inlineEditingElement = findNode(documentStore.document.tree, inlineEditingElementId);
    
    if (!activatedElement || !inlineEditingElement) {
      return;
    }

    let currentElement = activatedElement;
    let isChildOfInlineEditedElement = false;
    
    while (currentElement) {
      const parent = findNodeParent(documentStore.document.tree, currentElement);
      if (!parent) break;
      
      if (parent.id === inlineEditingElementId) {
        isChildOfInlineEditedElement = true;
        break;
      }
      
      currentElement = parent;
    }

    if (!isChildOfInlineEditedElement) {
      await stopInlineEditing();
    }
  });

}